import { User } from './http/user/types';

/**
 * Account 0 is an special account where the shareable
 * agents/skills are created and made available for all other accounts
 */
export const isInAccount0 = (user: User): boolean => user.account_id === 0;
